export default __webpack_public_path__ + "static/media/shelves.f8c884a5.png";